<goab-button-group *ngIf="backButtonText || buttonText">
  <goab-button
    *ngIf="backButtonText"
    (onClick)="backFeedback()"
    [type]="backButtonType"
    [attr.data-cy]="uniqueId + '-dialog-trigger-back-button'"
    >{{ backButtonText }}</goab-button
  >
  <goab-button
    *ngIf="buttonText"
    (onClick)="openModal(getCalloutVariant, $event)"
    [variant]="getButtonVariant"
    [type]="buttonType"
    [disabled]="buttonDisabled"
    [attr.data-cy]="uniqueId + '-dialog-trigger-button'"
    >{{ buttonText }}</goab-button
  >
</goab-button-group>
<a
  href="#"
  *ngIf="linkText"
  (click)="openModal(calloutVariant, $event)"
  [attr.data-cy]="uniqueId + '-dialog-trigger-link'"
  >{{ linkText }}</a
>

<ng-container *ngIf="displayContent">
  <span (click)="openModal(calloutVariant, $event)">
    <ng-content></ng-content>
  </span>
</ng-container>

<goab-modal
  [attr.id]="uniqueId + '-modal-dialog'"
  role="dialog"
  type="callout"
  [open]="isOpen"
  [calloutVariant]="calloutVariant ?? null"
  [heading]="headerText"
  closable="false"
  (onClose)="closeModal()"
  [maxWidth]="maxWidth"
>
  <div data-cy="feedback-step1" *ngIf="currentStep === 1">
    <h4 class="sub-title">{{ introMessage?.feedbackTitle }}</h4>
    <p [innerHTML]="safeIntroMessage"></p>
    <div slot="actions" class="button-row">
      <goab-button-group alignment="end">
        <goab-button
          *ngIf="cancelText"
          (onClick)="closeModal()"
          [type]="cancelButtonType"
          data-cy="cancel-button"
          size="compact"
          >{{ cancelText }}</goab-button
        >
        <goab-button
          *ngIf="startText"
          (onClick)="startFeedback()"
          type="primary"
          data-cy="start-button"
          size="compact"
          >{{ startText }}</goab-button
        >
      </goab-button-group>
    </div>
  </div>

  <div data-cy="feedback-step2" *ngIf="currentStep === 2" [formGroup]="formGroup">
    <div class="form-item">
      <goab-form-item label="How easy was it for you to use this service?" [error]="errorMessage('rating')">
        <goab-radio-group name="rating" formControlName="rating" [orientation]="isMobile ? 'vertical' : 'horizontal'">
          <goab-radio-item *ngFor="let rating of ratingsList" [value]="rating.key" [label]="rating.value">
          </goab-radio-item>
        </goab-radio-group>
      </goab-form-item>
    </div>
    <div class="form-item">
      <goab-form-item
        label="Do you have any additional comments?"
        requirement="optional"
        [helptext]="textAreaHelperText"
        [error]="errorMessage('comment')"
      >
        <goab-textarea
          width="99.5%"
          countby="character"
          [maxcount]="textAreaMaxLength"
          [showcount]="true"
          name="comment"
          formControlName="comment"
        ></goab-textarea>
      </goab-form-item>
    </div>

    <div class="form-item">
      <goab-form-item label="Did you experience any technical issues?" [error]="errorMessage('hasTechnicalIssues')">
        <goab-radio-group
          name="issues"
          (onChange)="issuesChanged()"
          formControlName="hasTechnicalIssues"
          orientation="horizontal"
        >
          <goab-radio-item value="yes" label="Yes"></goab-radio-item>
          <goab-radio-item value="no" label="No"></goab-radio-item>
        </goab-radio-group>
      </goab-form-item>
    </div>

    <div class="form-item" *ngIf="formGroup.controls.hasTechnicalIssues?.value === 'yes'">
      <goab-form-item
        label="Please describe the issue in detail"
        [error]="errorMessage('technicalIssue')"
        [helptext]="textAreaHelperText"
        [error]="errorMessage('technicalIssue')"
      >
        <goab-textarea
          width="99.5%"
          countby="character"
          [maxcount]="textAreaMaxLength"
          [showcount]="true"
          name="issuesDescription"
          formControlName="technicalIssue"
          placeholder="Mention the page or step where you experienced the issue, if applicable."
        ></goab-textarea>
      </goab-form-item>
    </div>

    <p class="footer-text" *ngIf="safeFooterMessage" [innerHTML]="safeFooterMessage"></p>

    <div slot="actions" class="button-row">
      <goab-button-group alignment="end">
        <goab-button *ngIf="cancelText" (onClick)="closeModal()" [type]="cancelButtonType" data-cy="cancel-button">{{
          cancelText
        }}</goab-button>
        <goab-button *ngIf="submitText" (onClick)="submitFeedback()" type="primary" data-cy="start-button">{{
          submitText
        }}</goab-button>
      </goab-button-group>
    </div>
  </div>

  <div data-cy="feedback-step3" *ngIf="currentStep === 3">
    <h4 class="sub-title">{{ thankYouMessage?.feedbackTitle }}</h4>
    <p [innerHTML]="safeThankYouMessage"></p>

    <div slot="actions" class="button-row">
      <goab-button-group alignment="end">
        <goab-button *ngIf="closeText" (onClick)="backFeedback()" type="primary" data-cy="close-button">{{
          closeText
        }}</goab-button>
      </goab-button-group>
    </div>
  </div>

  <div data-cy="feedback-step4" *ngIf="currentStep === 4">
    <h4 class="sub-title error">{{ feedbackError?.errorTitle }}</h4>
    <p [innerHTML]="safeFeedbackErrorMessage"></p>

    <div slot="actions" class="button-row">
      <goab-button-group alignment="end">
        <goab-button *ngIf="closeText" (onClick)="gotoStep(2)" type="secondary" data-cy="back-button">{{
          backText
        }}</goab-button>
        <goab-button *ngIf="closeText" (onClick)="backFeedback()" type="primary" data-cy="close-button">{{
          closeText
        }}</goab-button>
      </goab-button-group>
    </div>
  </div>
</goab-modal>
